import React, { useState } from 'react';
//HELPERS
import loginFormValidator from './loginFormValidator';
//COMPONENTS
import Input from 'tailwind-components/Input/Input';
import Button from 'tailwind-components/Button/Button';
//EXTERNALS
import { useDispatch, useSelector } from 'react-redux';
import { AuthenticationLogin } from 'state/actions/actions';

// the label is a <p> and no preflight runs, so its browser margins (1em top
// and bottom) opened a wide gap above every input
const LABEL_CLASSES = 'm-0 mb-1.5';

function NoMFALoginForm() {
  const isLoggingIn = useSelector(state => state.authentication.isLoggingIn);
  const dispatch = useDispatch();

  const [formState, setFormState] = useState({
    email: '',
    password: '',
    errors: {
      email: '',
      password: ''
    }
  });

  const onInputChange = e => {
    let target = e.target;
    setFormState({
      ...formState,
      [target.name]: target.value,
      errors: { ...formState.errors, [target.name]: '' }
    });
  };

  const onSubmit = e => {
    e.preventDefault();
    const { errors, isValid } = loginFormValidator(formState);
    if (isValid) {
      dispatch(AuthenticationLogin(formState, setFormState));
    } else {
      setFormState({ ...formState, errors });
    }
  };

  return (
    <form className='flex w-full flex-col gap-4'>
      <Input
        name='email'
        label='E-mail'
        labelClassName={LABEL_CLASSES}
        type='mail'
        error={formState.errors.email}
        placeholder='Enter your e-mail'
        onChange={onInputChange}
        autoFocus
      />
      <Input
        name='password'
        label='Password'
        labelClassName={LABEL_CLASSES}
        type='password'
        error={formState.errors.password}
        placeholder='Enter your password'
        onChange={onInputChange}
      />
      <Button
        style={{
          // flat baby blue: the same light stop the old navy gradient had in its
          // centre. inline so it also holds on hover, as the gradient used to
          background: '#40a8f6',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '20px'
        }}
        isLoading={isLoggingIn}
        disabled={isLoggingIn}
        text='Login'
        variant='primary'
        size='medium'
        rounded='small'
        type='submit'
        fill
        className='mt-2'
        onClick={onSubmit}
      />
    </form>
  );
}

export default NoMFALoginForm;
